<template>
  <v-container>
    <p>Edit cleaning supply</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="cleaning_supply.name"
              label="Name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="cleaning_supply.price"
              type="number"
              label="Price"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <app-supplier-list
          :suppliers="suppliers"
          :supplier_list="supplier_list"
        />
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateCleaningSupply"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'cleaning-supply-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CleaningSupplyEdit",
  components: {
    AppSupplierList: () => import('../components/supplier-list')
  },
  data: () => ({
    cleaning_supply_id: null,
    cleaning_supply: {
      name: null,
      price: null
    },
    supplier_list: [],
    suppliers: [],
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    this.getCleaningSupply(id)
  },
  methods: {
    async getCleaningSupply (id) {
      this.cleaning_supply_id = id
      try {
        const result = await this.$http.get(`/back-office/cleaning-supplies/${this.cleaning_supply_id}`, authHeader())
        this.cleaning_supply.name = result.data.name
        this.cleaning_supply.price = result.data.price
        this.suppliers = result.data.Suppliers
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateCleaningSupply () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/cleaning-supplies/${this.cleaning_supply_id}`, this.cleaning_supply, authHeader())
          let suppliers = []
          for (let supplier of this.supplier_list) {
            if (supplier.selected)
              suppliers.push(supplier.id)
          }
          await this.$http.put(`/back-office/cleaning-supplies/${this.cleaning_supply_id}/suppliers`, { suppliers }, authHeader())
          this.$router.push({ name: 'cleaning-supply-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.cleaning_supply.name) {
        alert('Please fill in cleaning supply name')
        return false
      }
      if (!this.cleaning_supply.price) {
        alert('Please fill in cleaning supply price')
        return false
      }
      return true
    },
  },
};
</script>
